/**
 * Webhook event scopes a publisher can subscribe to.
 *
 * <p>Kept in one place because the list is used by both the webhook list page and the webhook
 * detail page; duplicating it meant a new event type had to be added twice and was easy to miss.
 *
 * <p>Must stay in step with the backend `EventType` enum. An event that exists on the server but is
 * missing here simply cannot be subscribed to from the dashboard.
 */
export const WEBHOOK_SCOPES = [
  // Cashback
  { id: 'CASHBACK_CREATED', text: 'CASHBACK_CREATED' },
  { id: 'CASHBACK_REFUNDED', text: 'CASHBACK_REFUNDED' },
  { id: 'CASHBACK_BEING_VERIFIED', text: 'CASHBACK_BEING_VERIFIED' },
  { id: 'CASHBACK_VERIFIED', text: 'CASHBACK_VERIFIED' },
  { id: 'CASHBACK_DECLINED', text: 'CASHBACK_DECLINED' },
  { id: 'CASHBACK_RECEIVED', text: 'CASHBACK_RECEIVED' },
  { id: 'CASHBACK_PAID_TO_PUBLISHER', text: 'CASHBACK_PAID_TO_PUBLISHER' },
  { id: 'CASHBACK_DISQUALIFIED', text: 'CASHBACK_DISQUALIFIED' },

  // Offers
  { id: 'OFFER_APPROVED', text: 'OFFER_APPROVED' },
  { id: 'OFFER_REMOVED_FROM_PLATFORM', text: 'OFFER_REMOVED_FROM_PLATFORM' },
  { id: 'OFFER_REMOVED_FROM_PROGRAM', text: 'OFFER_REMOVED_FROM_PROGRAM' },
  { id: 'OFFER_UPDATED', text: 'OFFER_UPDATED' },
  { id: 'OFFER_ACTIVATED', text: 'OFFER_ACTIVATED' },
  { id: 'OFFER_DEACTIVATED', text: 'OFFER_DEACTIVATED' },
  { id: 'CLICK_TO_ACTIVATE_OFFER_EXPIRING_SOON', text: 'CLICK_TO_ACTIVATE_OFFER_EXPIRING_SOON' },
  { id: 'CLICK_TO_ACTIVATE_OFFER_EXPIRED', text: 'CLICK_TO_ACTIVATE_OFFER_EXPIRED' },

  // Tiers and users
  { id: 'TIER_CREATED', text: 'TIER_CREATED' },
  { id: 'TIER_REMOVED', text: 'TIER_REMOVED' },
  { id: 'USER_ADDED_TO_TIER', text: 'USER_ADDED_TO_TIER' },
  { id: 'USER_REMOVED_FROM_TIER', text: 'USER_REMOVED_FROM_TIER' },

  // Gift cards
  { id: 'GIFT_CARD_CREATED', text: 'GIFT_CARD_CREATED' },
  { id: 'GIFT_CARD_STATUS_UPDATED', text: 'GIFT_CARD_STATUS_UPDATED' },
  { id: 'GIFT_CARD_FULFILLED', text: 'GIFT_CARD_FULFILLED' },
  { id: 'GIFT_CARD_FAILED', text: 'GIFT_CARD_FAILED' },
  { id: 'GIFT_CARD_REFUNDED', text: 'GIFT_CARD_REFUNDED' },
  { id: 'GIFT_CARD_BALANCE_DEPOSITED', text: 'GIFT_CARD_BALANCE_DEPOSITED' },
  { id: 'GIFT_CARD_BALANCE_LOW', text: 'GIFT_CARD_BALANCE_LOW' },
  { id: 'GIFT_CARD_BALANCE_THRESHOLD_REACHED', text: 'GIFT_CARD_BALANCE_THRESHOLD_REACHED' },
  { id: 'GIFT_CARD_QUEUE_FROZEN', text: 'GIFT_CARD_QUEUE_FROZEN' },
  { id: 'GIFT_CARD_BRAND_ENABLED', text: 'GIFT_CARD_BRAND_ENABLED' },
  { id: 'GIFT_CARD_BRAND_DISABLED', text: 'GIFT_CARD_BRAND_DISABLED' },
  { id: 'GIFT_CARD_BRAND_UPDATED', text: 'GIFT_CARD_BRAND_UPDATED' },
  { id: 'GIFT_CARD_BRAND_REMOVED', text: 'GIFT_CARD_BRAND_REMOVED' },

  // Recommendations
  { id: 'RECOMMENDATION_NON_ACTIVATED_OFFER', text: 'RECOMMENDATION_NON_ACTIVATED_OFFER' },


]

export default WEBHOOK_SCOPES
